(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-reserve-timer"] && !Shopify.designMode) return;
  try {
    class CartReserveTimer extends HTMLElement {
    static KEY = 'cart-reserve-deadline';

    connectedCallback() {
      this.minutes = Number(this.dataset.minutes) || 10;
      this.restartAt = Number(this.dataset.restartAt) || 30;
      this.timeEl = this.querySelector('[ref="time"]');
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    get deadline() {
      try {
        return Number(sessionStorage.getItem(CartReserveTimer.KEY)) || 0;
      } catch (e) {
        return this._fallback || 0;
      }
    }

    restart() {
      const deadline = Date.now() + this.minutes * 60 * 1000;
      try {
        sessionStorage.setItem(CartReserveTimer.KEY, String(deadline));
      } catch (e) {
        this._fallback = deadline;
      }
      return deadline;
    }

    tick() {
      let deadline = this.deadline;
      let remaining = Math.round((deadline - Date.now()) / 1000);

      // No deadline yet, or we've reached the restart threshold → reset to full time.
      if (!deadline || remaining <= this.restartAt) {
        deadline = this.restart();
        remaining = Math.round((deadline - Date.now()) / 1000);
      }

      const m = String(Math.floor(remaining / 60)).padStart(2, '0');
      const s = String(remaining % 60).padStart(2, '0');
      if (this.timeEl) this.timeEl.textContent = `${m}:${s}`;
    }
  }

  if (!customElements.get('cart-reserve-timer')) {
    customElements.define('cart-reserve-timer', CartReserveTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
